import { render } from "./BlogCard.vue?vue&type=template&id=48ec0f70&ts=true"
import script from "./BlogCard.vue?vue&type=script&lang=ts"
export * from "./BlogCard.vue?vue&type=script&lang=ts"

import "./BlogCard.vue?vue&type=style&index=0&id=48ec0f70&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__